import React from 'react'

import iconHeartMaskAfro from '../images/icon-heart-mask-afro.svg'

const Footer = () => (
  <footer className='footer' role='contentinfo'>
    <div className='container'>
      <div>
        <img
          className='icon-text__header-image'
          src={iconHeartMaskAfro}
          alt=''
        />
      </div>

      <p>
        <strong>1Dollar1Love</strong> is committed to full transparency and
        accountability. For questions or for more information, please contact{' '}
        <a href='mailto:hello@1dollar1love.org'>hello@1dollar1love.org</a>.
      </p>

      <a
        className='donate-cta'
        href='https://app.mobilecause.com/public/peer_fundraisers/558743/peer_fundraiser_donations/new?vid=8l14i'
      >
        Donate Now
      </a>
    </div>
  </footer>
)

export default Footer
